export const countries = [
  { "name": "Afghanistan", "code": "+93", "flag": "🇦🇫" },
  { "name": "Albania", "code": "+355", "flag": "🇦🇱" },
  { "name": "Algeria", "code": "+213", "flag": "🇩🇿" },
  { "name": "Andorra", "code": "+376", "flag": "🇦🇩" },
  { "name": "Angola", "code": "+244", "flag": "🇦🇴" },
  { "name": "Argentina", "code": "+54", "flag": "🇦🇷" },
  { "name": "Armenia", "code": "+374", "flag": "🇦🇲" },
  { "name": "Australia", "code": "+61", "flag": "🇦🇺" },
  { "name": "Austria", "code": "+43", "flag": "🇦🇹" },
  { "name": "Azerbaijan", "code": "+994", "flag": "🇦🇿" },
  { "name": "Bahamas", "code": "+1242", "flag": "🇧🇸" },
  { "name": "Bahrain", "code": "+973", "flag": "🇧🇭" },
  { "name": "Bangladesh", "code": "+880", "flag": "🇧🇩" },
  { "name": "Belarus", "code": "+375", "flag": "🇧🇾" },
  { "name": "Belgium", "code": "+32", "flag": "🇧🇪" },
  { "name": "Belize", "code": "+501", "flag": "🇧🇿" },
  { "name": "Benin", "code": "+229", "flag": "🇧🇯" },
  { "name": "Bhutan", "code": "+975", "flag": "🇧🇹" },
  { "name": "Bolivia", "code": "+591", "flag": "🇧🇴" },
  { "name": "Bosnia and Herzegovina", "code": "+387", "flag": "🇧🇦" },
  { "name": "Botswana", "code": "+267", "flag": "🇧🇼" },
  { "name": "Brazil", "code": "+55", "flag": "🇧🇷" },
  { "name": "Brunei", "code": "+673", "flag": "🇧🇳" },
  { "name": "Bulgaria", "code": "+359", "flag": "🇧🇬" },
  { "name": "Cambodia", "code": "+855", "flag": "🇰🇭" },
  { "name": "Cameroon", "code": "+237", "flag": "🇨🇲" },
  { "name": "Canada", "code": "+1", "flag": "🇨🇦" },
  { "name": "Chad", "code": "+235", "flag": "🇹🇩" },
  { "name": "Chile", "code": "+56", "flag": "🇨🇱" },
  { "name": "China", "code": "+86", "flag": "🇨🇳" },
  { "name": "Colombia", "code": "+57", "flag": "🇨🇴" },
  { "name": "Costa Rica", "code": "+506", "flag": "🇨🇷" },
  { "name": "Croatia", "code": "+385", "flag": "🇭🇷" },
  { "name": "Cuba", "code": "+53", "flag": "🇨🇺" },
  { "name": "Cyprus", "code": "+357", "flag": "🇨🇾" },
  { "name": "Czech Republic", "code": "+420", "flag": "🇨🇿" },
  { "name": "Denmark", "code": "+45", "flag": "🇩🇰" },
  { "name": "Dominican Republic", "code": "+1", "flag": "🇩🇴" },
  { "name": "Ecuador", "code": "+593", "flag": "🇪🇨" },
  { "name": "Egypt", "code": "+20", "flag": "🇪🇬" },
  { "name": "Estonia", "code": "+372", "flag": "🇪🇪" },
  { "name": "Finland", "code": "+358", "flag": "🇫🇮" },
  { "name": "France", "code": "+33", "flag": "🇫🇷" },
  { "name": "Georgia", "code": "+995", "flag": "🇬🇪" },
  { "name": "Germany", "code": "+49", "flag": "🇩🇪" },
  { "name": "Ghana", "code": "+233", "flag": "🇬🇭" },
  { "name": "Greece", "code": "+30", "flag": "🇬🇷" },
  { "name": "Hong Kong", "code": "+852", "flag": "🇭🇰" },
  { "name": "Hungary", "code": "+36", "flag": "🇭🇺" },
  { "name": "Iceland", "code": "+354", "flag": "🇮🇸" },
  { "name": "India", "code": "+91", "flag": "🇮🇳" },
  { "name": "Indonesia", "code": "+62", "flag": "🇮🇩" },
  { "name": "Iraq", "code": "+964", "flag": "🇮🇶" },
  { "name": "Ireland", "code": "+353", "flag": "🇮🇪" },
  { "name": "Israel", "code": "+972", "flag": "🇮🇱" },
  { "name": "Italy", "code": "+39", "flag": "🇮🇹" },
  { "name": "Japan", "code": "+81", "flag": "🇯🇵" },
  { "name": "Jordan", "code": "+962", "flag": "🇯🇴" },
  { "name": "Kenya", "code": "+254", "flag": "🇰🇪" },
  { "name": "Kuwait", "code": "+965", "flag": "🇰🇼" },
  { "name": "Lebanon", "code": "+961", "flag": "🇱🇧" },
  { "name": "Malaysia", "code": "+60", "flag": "🇲🇾" },
  { "name": "Maldives", "code": "+960", "flag": "🇲🇻" },
  { "name": "Mexico", "code": "+52", "flag": "🇲🇽" },
  { "name": "Nepal", "code": "+977", "flag": "🇳🇵" },
  { "name": "Netherlands", "code": "+31", "flag": "🇳🇱" },
  { "name": "New Zealand", "code": "+64", "flag": "🇳🇿" },
  { "name": "Nigeria", "code": "+234", "flag": "🇳🇬" },
  { "name": "Norway", "code": "+47", "flag": "🇳🇴" },
  { "name": "Oman", "code": "+968", "flag": "🇴🇲" },
  { "name": "Pakistan", "code": "+92", "flag": "🇵🇰" },
  { "name": "Philippines", "code": "+63", "flag": "🇵🇭" },
  { "name": "Poland", "code": "+48", "flag": "🇵🇱" },
  { "name": "Portugal", "code": "+351", "flag": "🇵🇹" },
  { "name": "Qatar", "code": "+974", "flag": "🇶🇦" },
  { "name": "Romania", "code": "+40", "flag": "🇷🇴" },
  { "name": "Russia", "code": "+7", "flag": "🇷🇺" },
  { "name": "Saudi Arabia", "code": "+966", "flag": "🇸🇦" },
  { "name": "Singapore", "code": "+65", "flag": "🇸🇬" },
  { "name": "South Africa", "code": "+27", "flag": "🇿🇦" },
  { "name": "South Korea", "code": "+82", "flag": "🇰🇷" },
  { "name": "Spain", "code": "+34", "flag": "🇪🇸" },
  { "name": "Sri Lanka", "code": "+94", "flag": "🇱🇰" },
  { "name": "Sweden", "code": "+46", "flag": "🇸🇪" },
  { "name": "Switzerland", "code": "+41", "flag": "🇨🇭" },
  { "name": "Thailand", "code": "+66", "flag": "🇹🇭" },
  { "name": "Turkey", "code": "+90", "flag": "🇹🇷" },
  { "name": "UAE", "code": "+971", "flag": "🇦🇪" },
  { "name": "Uganda", "code": "+256", "flag": "🇺🇬" },
  { "name": "Ukraine", "code": "+380", "flag": "🇺🇦" },
  { "name": "United Kingdom", "code": "+44", "flag": "🇬🇧" },
  { "name": "United States", "code": "+1", "flag": "🇺🇸" },
  { "name": "Vietnam", "code": "+84", "flag": "🇻🇳" }
]
